<template>
  <div class="mypage notranslate">
    <div class="mb30">
      <h1 class="boxTitle mb15 toCapitalize">{{locale.mypage}}</h1>
      <!-- <div v-if="mypage && (mypage.room || mypage.checkin || mypage.checkout)" class="info">
        <div v-if="mypage && mypage.room" class="room">{{space}}</div>
        <div v-if="mypage && mypage.checkin" class="period"><span class="label">CHECK-IN</span><span class="colorGrey">{{dateFormatWidthTz(stayAfter)}}</span></div>
        <div v-if="mypage && mypage.checkout" class="period"><span class="label">CHECK-OUT</span><span class="colorGrey">{{dateFormatWidthTz(stayBefore)}}</span></div>
      </div> -->
      <div v-if="mypageProperties === 'fail'" class="noData">{{locale.fail_request}}</div>
      <div v-else-if="mypageProperties && mypageProperties.length" class="list toCapitalize">
        <router-link v-for="property in mypageProperties"
          :key="property.id"
          :to="{name: property.routerName}"
          :class="property.className"
          class="item horizontal">
          {{locale[property.name]}}
          <i class="cnt"
            :data-cnt="`${property.count || 0}`"
            :style="property.count > 0 && { ...skinStyle('countBg', 'background-color'), ...skinStyle('countText', 'color') }">
            {{property.count || 0}}
          </i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import regExp from '@/common/regExp'

export default {
  name: 'Mypage',
  props: [
    'lang',
    'locale',
    'roomKey',
  ],
  components: {
  },
  computed: {
    ...mapGetters({
      cartList: 'cart/getList',
      getMetaInfo: 'authentication/getMetaInfo'
    }),
    setting () {
      return this.$store.state.common.setting
    },
    mypage () {
      return this.setting && this.setting.mypage
    },
    dateFormat () {
      const setting = this.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm:ss'
      return `${this.dateFormat} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    couponKey () {
      const hasOid = !!this.oid && this.oid !== 'undefined' && this.oid !== 'na'
      const key = this.roomKey !== null ? `spaceid=${this.space}&k=${this.key}` : hasOid ? `oid=${this.oid}` : null
      return key
    },
    space () {
      const space = this.$store.state.authentication.space
      return space && space !== 'undefined' ? space : '-'
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    }
  },
  async mounted () {
    // 주문내역에서 제외할 전송코드
    const notInclude = /reservation|morningcall|parking|mobility|tip/
    const propertyList = this.setMypageProperties()
    const properties = (propertyList && propertyList.map(x => x.id).filter(x => x !== 'cart')) || null // 장바구니는 로컬스토리지에서 계산하므로 api호출시 제외
    await this.getKey()
    this.$store.commit('loading', true)
    const mypageInfo = await this.$store.dispatch('guest/getMypageInfo', properties)
    const cartList = this.cartList() || []
    const cartCount = (cartList && cartList.length) || 0
    this.mypageProperties = mypageInfo
      ? propertyList.map(x => {
        const count = x.id === 'cart' ? cartCount : (mypageInfo && mypageInfo[x.id]) || 0
        return {
          ...x,
          count: count
        }
      })
      : propertyList
    this.$store.commit('loading', false)
  },
  data () {
    return {
      coupon: 0,
      order: 0,
      payment: 0,
      reservation: 0,
      stayAfter: '-',
      stayBefore: '-',
      key: this.$store.state.authentication ? this.$store.state.authentication.k : null,
      oid: this.$store.state.authentication ? this.$store.state.authentication.oid : null,
      mypageProperties: []
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'mypage'
      })
    },
    setMypageProperties () {
      const isDisabled = (property) => this.mypage && this.mypage[property] === false
      const properties = [
        'cart',
        'order',
        'payment',
        'reservation',
        'coupon',
        'mobility'
      ]
      const getPropertyName = (property) => {
        const list = /order|payment|reservation/
        const my = /mobility/
        let name = property
        if (list.test(property)) {
          name = `${property}_list`
        } else if (my.test(property)) {
          name = `${property}_my`
        }
        return name
      }
      const getRouterName = (property) => {
        const my = /order|payment|reservation|mobility/
        let name = property
        if (my.test(property)) {
          name = `my${toCapitalized(property)}`
        }
        return name
      }
      function toCapitalized (str) {
        return regExp.toCapitalized(str)
      }
      return properties.filter(x => !isDisabled(x)).map(x => {
        return {
          id: x,
          name: getPropertyName(x),
          routerName: getRouterName(x),
          className: `my${toCapitalized(x)}`
        }
      })
    },
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    init () {
      this.track()
    },
    dateFormatWidthTz (iso) {
      const tzDateTime = DateTime.fromISO(iso, { zone: this.timezone })
      return iso === '-' ? '-' : tzDateTime.toFormat(this.format)
    }
  }
}
</script>

<style lang="scss" scoped>
.info {
  margin-bottom: 15px;
  padding: 30px;
  border-radius: 4px;
  border: 1px solid $color-lgrey2;
  background: linear-gradient(135deg, $color-white 30%, $bg-default);
  .room {
    font-size: 2em;
    font-weight: 700;
    & + .period {
      margin-top: 30px;
    }
  }
  .period {
    display: flex;
    align-items: center;
    .label {
      width: 108px;
      margin-right: 10px;
      padding: 5px 0 5px 15px;
      font-size: 0.85em;
      border-radius: 50px;
      border: 1px solid $color-lgrey2;
      background-color: $color-lgrey2;
      background: linear-gradient(135deg, $bg-default, $color-lgrey2);
    }
    & + .period {
      margin-top: 5px;
    }
  }
}
.list {
  .item {
    display: flex;
    align-items: center;
    position: relative;
    padding: 15px 10px 15px 30px;
    text-align: center;
    word-break: keep-all;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    background: linear-gradient(135deg, $color-white 50%, $bg-default);
    & + .item {
      margin-top: 5px;
    }
    &:before {
      content: "";
      display: block;
      width: 24px;
      height: 24px;
      margin-right: 15px;
      background-size: contain;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      opacity: 0.8;
    }
    &.myCart:before {
      background-image: url('~@/assets/img/ico_mypage_cart.png');
    }
    &.myOrder:before {
      background-image: url('~@/assets/img/ico_mypage_order.png');
    }
    &.myPayment:before {
      background-image: url('~@/assets/img/ico_mypage_payment.png');
    }
    &.myReservation:before {
      background-image: url('~@/assets/img/ico_mypage_reservation.png');
    }
    &.myCoupon:before {
      background-image: url('~@/assets/img/ico_mypage_coupon.png');
    }
    &.myMobility:before {
      background-image: url('~@/assets/img/ico_mypage_mobility.png');
    }
    .cnt {
      position: absolute;
      top: 50%;
      right: 10px;
      min-width: 20px;
      height: 20px;
      margin-top: -10px;
      padding-left: 5px;
      padding-right: 5px;
      text-align: center;
      font-size: 12px;
      font-weight: 700;
      line-height: 20px;
      border-radius: 30px;
      white-space: nowrap;
      color: $color-white;
      background-color: $color-primary;
      &[data-cnt="0"] {
        background-color: $color-lgrey;
      }
    }
  }
  .myCheckout {
    flex: none;
    margin-top: 15px;
    border-radius: 4px;
    &:before {
      display: none;
    }
  }
}
.shortcut {
  border-top: 1px solid $color-lgrey2;
  .item {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid $color-lgrey2;
    &:before {
      content: "";
      width: 32px;
      height: 32px;
      margin-right: 8px;
      background-size: contain;
      background-position: 50% 50%;
      background-repeat: no-repeat;
    }
    &.myAmenity:before {
      background-image: url('~@/assets/img/ico_amenity.png');
    }
    &.myChannelGuide:before {
      background-image: url('~@/assets/img/ico_tv.png');
    }
    &.myLocalinfo:before {
      background-image: url('~@/assets/img/ico_localinfo.png');
    }
  }
}
@media screen and (min-width: 768px) {
  .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 4px;
    column-gap: 4px;
    overflow: hidden;
    border-radius: 4px;
    .item {
      display: block;
      padding: 60px 0 40px;
      & + .item {
        margin-top: 0;
      }
      &:before {
        width: 32px;
        height: 32px;
        margin: 0 auto 15px;
      }
      .cnt {
        top: 10px;
        min-width: 30px;
        height: 30px;
        margin-top: 0;
        font-size: 14px;
        line-height: 30px;
      }
    }
  }
}
.noData {
  padding: 120px 15px;
  text-align: center;
  font-size: 24px;
  border: 1px solid $color-lgrey2;
  border-radius: 8px;
  background-color: $bg-default;
}
@media screen and (min-width: 1024px) {
  .list {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
